import React, { useContext } from "react";

import Tabs from "components/shared/Tabs";
import { useTranslation } from "react-i18next";

import { AuthContext } from "shared/context/auth-context";
import Plans from "components/settings/Plans";
import AccountSettings from "components/settings/AccountSettings";
import ProfileSettings from "components/settings/ProfileSettings";

const AnalysisManagement = () => {
  const auth = useContext(AuthContext);
  const { t } = useTranslation();

  const [tabValue, setTabValue] = React.useState(0);
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  let settingsTab = [];

  settingsTab.push({
    label: t("accountSettings"),
    content: <AccountSettings></AccountSettings>,
  });

  settingsTab.push({
    label: t("plans"),
    content: <Plans></Plans>,
  });

  // settingsTab.push({
  //   label: t("clientInformation"),
  //   content: <ClientManagement></ClientManagement>,
  // });

  return (
    <React.Fragment>
      <Tabs tabs={settingsTab} tabValue={tabValue} onTabChange={handleTabChange} isVertical={true} />
    </React.Fragment>
  );
};

export default AnalysisManagement;
